import React, { Component } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Heading, Map } from '../../components';
import OnlineImage from "../../assets/online-session.jpeg"

import css from './ListingPage.module.css';

/**
 * The SectionMapMaybe component.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {propTypes.latlng} [props.geolocation] - The geolocation
 * @param {propTypes.uuid} props.listingId - The listing id
 * @returns {JSX.Element} section map maybe component
 */
class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig, selectedSession } = this.props;

    // If no session is selected, show prompt
    if (!selectedSession) {
      return (
        <section className={classNames(rootClassName || css.sectionMap, className)} id="listing-location">
          <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
            <FormattedMessage id="ListingPage.locationTitle" />
          </Heading>
          <p className={css.locationPrompt}>
            Please select a session to view location
          </p>
        </section>
      );
    }

    // Online sessions have no coordinates to plot -- show the online-session
    // graphic directly instead of falling into the lat/lng guard below
    // (selectedSession.isOnline is a plain boolean, not a location object;
    // reading .lat/.lng off it was always undefined, so that guard used to
    // return null for every online session before this branch was reached).
    if (selectedSession.isOnline) {
      return (
        <section className={classNames(rootClassName || css.sectionMap, className)} id="listing-location">
          <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
            <FormattedMessage id="ListingPage.locationTitle" />
          </Heading>
          <img src={OnlineImage} className={css.onlineImage} alt="Online Session" />
        </section>
      );
    }

    // If session is selected but has no location data
    const sessionLocation = selectedSession.location;
    if (!sessionLocation || !sessionLocation.lat || !sessionLocation.lng) {
      return null;
    }

    const { address, lat, lng } = sessionLocation;
    const center = { lat, lng };

    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${lat}_${lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(center, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center };

    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <section className={classes} id="listing-location">
        <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </Heading>
        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
      </section>
    );
  }
}

export default SectionMapMaybe;
